// packages/api-types/src/responses.ts
import { AvlEvent, DeviceDetails, RegenHourFuel, TVDashboardData } from './models.js';

export const API_ROUTES = {
  FUEL_REGEN: '/api/fuelregen/:deviceid',
  DEVICES: '/api/devices',
  DEVICE_EVENTS: '/api/events/device/:deviceId/from/:startTime',
  TV_DASHBOARD: '/api/tv/:uuid',
} as const;

export interface ApiResponse<T> {
  data: T;
  status: number;
}

export class ApiError extends Error {
  constructor(public message: string, public statusCode?: number) {
    super(message);
    this.name = 'ApiError';
  }
}

export interface DeviceEventsResponse {
  deviceId: number;
  startTime: string;
  endTime: string;
  events: AvlEvent[];
  totalCount: number | null;
  isTruncated: boolean;
  message?: string;
}

export interface ApiRoutes {
    [API_ROUTES.FUEL_REGEN]: {
    get: {
      params: { deviceid: number };
      response: RegenHourFuel[] | ApiError;
    };
  },
  [API_ROUTES.DEVICES]: {
    get: {
      response: DeviceDetails[] | ApiError;
    };
  },
  [API_ROUTES.DEVICE_EVENTS]:{
    get:{
      params: {
        deviceId: number;
        startTime: string
      };
      response: DeviceEventsResponse | ApiError

    }
  },
  [API_ROUTES.TV_DASHBOARD]: {
    get: {
      params: { uuid: string };
      response: TVDashboardData | ApiError;
    };
  }
}
